module.exports = __webpack_public_path__ + "static/media/epidorpio.2529651c.jpg";